import script from "./VAppSidebarExplorer.vue?vue&type=script&setup=true&lang=ts"
export * from "./VAppSidebarExplorer.vue?vue&type=script&setup=true&lang=ts"

import "./VAppSidebarExplorer.vue?vue&type=style&index=0&id=1431816c&lang=scss"

const __exports__ = script;

export default __exports__